import { FC, useEffect, useState } from 'react';
import { Keyboard, Platform, StyleSheet } from 'react-native';
import { Appbar } from 'react-native-paper';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { TopBarProps } from './types';

export const BottomBar: FC<Omit<TopBarProps, 'title'>> = (
  props: Omit<TopBarProps, 'title'>
) => {
  const insets = useSafeAreaInsets();
  const [keyboardHeight, setKeyboardHeight] = useState(0);
  const baseBottom = 15;

  useEffect(() => {
    // Only listen to keyboard events on mobile platforms
    if (Platform.OS === 'web') {
      return;
    }

    const showSubscription = Keyboard.addListener(
      Platform.OS === 'ios' ? 'keyboardWillShow' : 'keyboardDidShow',
      (e) => {
        setKeyboardHeight(e.endCoordinates.height);
      }
    );
    const hideSubscription = Keyboard.addListener(
      Platform.OS === 'ios' ? 'keyboardWillHide' : 'keyboardDidHide',
      () => {
        setKeyboardHeight(0);
      }
    );

    return () => {
      showSubscription.remove();
      hideSubscription.remove();
    };
  }, []);

  // Apply safe area bottom inset on both iOS and Android when keyboard is hidden
  // (avoids overlap with home indicator on iOS and gesture navigation area on Android)
  const safeAreaBottom = keyboardHeight === 0 ? insets.bottom : 0;
  const bottomPosition = baseBottom + keyboardHeight + safeAreaBottom;

  return (
    <Appbar.Header
      statusBarHeight={0}
      mode="center-aligned"
      style={[
        props.style
          ? [props.style, styles.footerContainer]
          : styles.footerContainer,
        !props.hideBottomBorder && styles.bottomBorder,
        { bottom: bottomPosition },
      ]}
    >
      {props.left}
      {props.additionalHeaderBlock}
      {props.right}
    </Appbar.Header>
  );
};

const styles = StyleSheet.create({
  footerContainer: {
    position: 'absolute',
    backgroundColor: 'transparent',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlignVertical: 'center',
    width: '100%',
    columnGap: 16,
    paddingRight: 20,
  },
  bottomBorder: {
    elevation: 3,
  },
});
